module.exports = __webpack_public_path__ + "static/media/kid-decorating-cupcake-with-help.2e43dfc9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/2017-11-4/kid-decorating-cupcake-with-help.jpg
// module id = 803
// module chunks = 0